import React from 'react';
import PropTypes from 'prop-types';
import { Item } from 'semantic-ui-react';
import WalkInSection from './WalkInSection';
import css from './ConnectionHeader.scss';
import { imageStyle } from "../../utils/images";
import { SFEntityID, OfficeHours } from 'utils/types';
import { isEmpty } from 'lodash';

export default class ConnectionHeader extends React.Component {

  get walkInSection() {
    // Only displayed when scheduling, other pages will not pass this
    if (!this.props.officeHours) return null;
    const walkInOfficeHours = this.props.officeHours.filter(({walkInsOnly}) => walkInsOnly);
    return isEmpty(walkInOfficeHours) ? null :
      <WalkInSection personId={this.props.personId} walkInOfficeHours={walkInOfficeHours} />;
  }

  render() {
    const { fullName, roles, title } = this.props;
    return (
      <Item.Group unstackable className={css['item-group-container']}>
        <Item className={css['item-container']}>
          <div><div className={css['image']} style={imageStyle(this.props.uuid, this.props.photoAvailable)} /></div>
          <Item.Content className={css['content']}>
            <Item.Header className={css['header']}>{fullName}</Item.Header>
            <Item.Meta className={css['meta']}>{title ? title : roles.join(', ')}</Item.Meta>
          </Item.Content>
          {this.walkInSection}
        </Item>
      </Item.Group>
    );
  }
}

ConnectionHeader.propTypes = {
  officeHours: OfficeHours,
  personId: SFEntityID.isRequired,
  uuid: PropTypes.string.isRequired,
  fullName: PropTypes.string.isRequired,
  roles: PropTypes.arrayOf(PropTypes.string).isRequired,
  photoAvailable: PropTypes.bool,
  title: PropTypes.string
};
